module.exports = __webpack_public_path__ + "img/symbol_8.93662405.png";